﻿import bulmaCollapsible from '@creativebulma/bulma-collapsible';

window.addEventListener('load', () => {
    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible:not(.facet-field):not(.facet-form-container)');
});